import { render, staticRenderFns } from "./DesktopGallery.vue?vue&type=template&id=36c8643a&"
import script from "./DesktopGallery.vue?vue&type=script&lang=js&"
export * from "./DesktopGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports